<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
<!-- Header -->
<div id="header-container">
  <div>
    <h1 id="header-text">Vehicle Scenario Duplicate Record Maintenance</h1>
  </div>

  <div id="button-container" class="button-container">
    <button mat-raised-button id="remove-dupe-button"
            class="remove-dupe-button"
            color="warn"
            (click)="removeDupes()"
            [disabled]="selectedRow === null">
      Remove Dupes
    </button>
    <button mat-raised-button id="scan-button"
            class="scan-button"
            color="primary"
            (click)="scanVehScenDupes()">
      Scan for Dupes
    </button>
  </div>
</div>

<!--    Main Option Table-->
<div class="gfs-table" *ngIf="this.vehScenWithDupes !== null && this.vehScenWithDupes?.length > 0">

  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="vehScenWithDupes"
    [columnDefs]="vehScenColumns"
    [autoSizeStrategy]="autoSizeStrategy"
    [rowSelection]="rowSelection"
    (rowSelected)="onSelect($event)"
  ></ag-grid-angular>
</div>
